import React, { useEffect, useState } from 'react';
import { Box, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, CircularProgress } from '@mui/material';
import axios from 'axios';
import { getBackendUserUrl } from '../../../utils/utils';

const AgendaPanel = ({ eventId }) => {
    const [agendaItems, setAgendaItems] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchAgendaItems = async () => {
            setLoading(true);
            setError(null);
            try {
                // Fetch agenda items with assignees and space details
                const response = await axios.get(`${getBackendUserUrl()}/agenda/agenda_items/${eventId}?include_assignees=true`);
                setAgendaItems(response.data || []);
            } catch (err) {
                setError('Failed to load agenda items');
            } finally {
                setLoading(false);
            }
        };
        if (eventId) fetchAgendaItems();
    }, [eventId]);

    if (loading) {
        return <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: 120 }}><CircularProgress /></Box>;
    }
    if (error) {
        return <Typography color="error">{error}</Typography>;
    }
    if (!agendaItems.length) {
        return <Typography>No agenda items found.</Typography>;
    }

    return (
        <TableContainer component={Paper}>
            <Table size="small" stickyHeader>
                <TableHead>
                    <TableRow>
                        <TableCell>Agenda Item Title</TableCell>
                        <TableCell>Space</TableCell>
                        <TableCell>Date</TableCell>
                        <TableCell>Start Time</TableCell>
                        <TableCell>End Time</TableCell>
                        <TableCell>Assignment Group</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {agendaItems.map(item => {
                        // Get space name
                        const spaceName = item.space?.name || item.spaceId || '--';
                        // Get assignment group name (if any)
                        let groupName = '--';
                        if (item.AgendaAssignees && item.AgendaAssignees.length > 0) {
                            // Use the first group name (could be extended to show all)
                            const group = item.AgendaAssignees[0].AgendaAssignmentGroup;
                            groupName = group?.name || '--';
                        }
                        return (
                            <TableRow key={item.agendaId || item.id}>
                                <TableCell>{item.name}</TableCell>
                                <TableCell>{spaceName}</TableCell>
                                <TableCell>{item.date || '--'}</TableCell>
                                <TableCell>{item.startTime || '--'}</TableCell>
                                <TableCell>{item.endTime || '--'}</TableCell>
                                <TableCell>{groupName}</TableCell>
                            </TableRow>
                        );
                    })}
                </TableBody>
            </Table>
        </TableContainer>
    );
};

export default AgendaPanel; 